__turbopack_context__.v({
  "accept-terms-link": "hDayua_accept-terms-link",
  "forgot-password": "hDayua_forgot-password",
  "forgot-view": "hDayua_forgot-view",
  "form-actions": "hDayua_form-actions",
  "form-below-options": "hDayua_form-below-options",
  "form-logo": "hDayua_form-logo",
  "google-container": "hDayua_google-container",
  "google-subtext": "hDayua_google-subtext",
  "inputLabel": "hDayua_inputLabel",
  "label": "hDayua_label",
  "login-link": "hDayua_login-link",
  "login-view-form": "hDayua_login-view-form",
  "logo": "hDayua_logo",
  "message-txt": "hDayua_message-txt",
  "message-wrap": "hDayua_message-wrap",
  "recover-password-btn": "hDayua_recover-password-btn",
  "reset-password": "hDayua_reset-password",
  "reset-password-button-container": "hDayua_reset-password-button-container",
  "reset-password-form-container": "hDayua_reset-password-form-container",
  "reset-password-title": "hDayua_reset-password-title",
  "rutInput": "hDayua_rutInput",
  "rutInputContainer": "hDayua_rutInputContainer",
  "sign-up-view": "hDayua_sign-up-view",
  "signup-link": "hDayua_signup-link",
  "submit": "hDayua_submit",
  "welcomeSubtitle": "hDayua_welcomeSubtitle",
  "welcomeTitle": "hDayua_welcomeTitle",
});
